/**
 * Centralized query key factory for TanStack Query.
 *
 * All query keys for the web panel are defined here for consistency
 * and easy invalidation patterns.
 */
export const queryKeys = {
  dashboard: {
    stats: ['dashboard', 'stats'] as const,
  },
  accounts: {
    all: ['accounts'] as const,
    list: (filters?: Record<string, unknown>) =>
      ['accounts', 'list', filters] as const,
    detail: (id: string) => ['accounts', 'detail', id] as const,
    profile: (id: string) => ['accounts', 'profile', id] as const,
  },
  integrations: {
    all: ['integrations'] as const,
    list: (filters?: Record<string, unknown>) =>
      ['integrations', 'list', filters] as const,
  },
  commands: {
    all: ['commands'] as const,
    list: (filters?: Record<string, unknown>) =>
      ['commands', 'list', filters] as const,
  },
  events: {
    all: ['events'] as const,
    list: (filters?: Record<string, unknown>) =>
      ['events', 'list', filters] as const,
  },
  sales: {
    all: ['sales'] as const,
    list: (filters?: Record<string, unknown>) =>
      ['sales', 'list', filters] as const,
  },
  audit: {
    all: ['audit'] as const,
    list: (filters?: Record<string, unknown>) =>
      ['audit', 'list', filters] as const,
  },
  auth: {
    session: ['auth', 'session'] as const,
  },
  notifications: {
    all: ['notifications'] as const,
    telegramStatus: () => ['notifications', 'telegram-status'] as const,
  },
  accountAssignments: {
    all: ['account-assignments'] as const,
    forAccount: (adAccountId: string) =>
      ['account-assignments', adAccountId] as const,
  },
} as const;
